// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, interval, Observable, of } from 'rxjs';
import { catchError, debounceTime, filter, map, tap, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authStatusSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.authStatusSubject.asObservable();
  public redirectUrl: string | null = null;
  private idleTimeOut = 60 * 15; //15 minutes
  private idleSubject = new BehaviorSubject<number>(this.idleTimeOut);
  private idleCountdown!: Observable<number>;
  constructor(private http: HttpClient) {
    // Check authentication status when service is initialized

    this.checkAuthStatus();
    this.idleCountdown = interval(1000);

    this.authStatusSubject.subscribe((auth) => {
      if (auth) {
        this.idleCountdown.subscribe((time) => {
          this.idleSubject.next(this.idleSubject.value - 1);
        });
      }
    });

    this.idleSubject.subscribe({
      next: (value) => {
        if (value == 0) {
          this.logout().subscribe((_) => {
            window.location.reload();
          });
        }
      },
    });
  }

  private resetIdle() {
    this.idleSubject.next(this.idleTimeOut);
  }

  // Method to check if the user is authenticated with the server
  checkAuthStatus(): Observable<boolean> {
    return this.http.get<any>('/api/user/isauthenticated', { withCredentials: true }).pipe(
      filter((isAuth) => isAuth !== null),
      tap(() => {
        this.resetIdle();
      }),
      map((response) => {
        console.log(response);
        const isAuthenticated = response === true;

        this.authStatusSubject.next(isAuthenticated);
        return isAuthenticated;
      }),
      catchError((error) => {
        this.authStatusSubject.next(false);
        return of(false);
      })
    );
  }

  login(credentials: { username: string; password: string }): Observable<any> {
    return this.http.post<any>('/api/user/login', credentials).pipe(
      tap((response) => {
        // The cookie will be set automatically by the browser
        this.authStatusSubject.next(true);
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  logout(): Observable<any> {
    return this.http.post<any>('/api/user/logout', {}).pipe(
      tap(() => {
        this.authStatusSubject.next(false);
      }),
      catchError((error) => {
        throw error;
      })
    );
  }
}
